import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle, ArrowClockwise } from "@phosphor-icons/react";
import { apiClient } from "../lib/api";
import Header from "../components/Header";

export default function ResumeSession() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | failed

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await apiClient.get(`/wizard/session/${token}`);
        if (cancelled) return;
        // Hand state off to the wizard page via sessionStorage
        sessionStorage.setItem("hipower_resume_state", JSON.stringify(data.state));
        if (data.current_step) {
          sessionStorage.setItem("hipower_resume_step", data.current_step);
        }
        setStatus("success");
        toast.success("Welcome back — picking up where you left off");
        setTimeout(() => navigate("/analyze"), 800);
      } catch (e) {
        if (cancelled) return;
        setStatus("failed");
        toast.error("Resume link expired or invalid");
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header variant="default" />
      <div className="pt-32 max-w-md mx-auto px-6 text-center">
        {status === "loading" && (
          <div data-testid="resume-loading">
            <ArrowClockwise size={48} weight="duotone" className="text-sky-500 mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-2xl font-bold text-slate-950">Loading your saved analysis...</h1>
          </div>
        )}
        {status === "success" && (
          <div data-testid="resume-success">
            <CheckCircle size={56} weight="fill" className="text-emerald-500 mx-auto mb-6" />
            <h1 className="font-display text-2xl font-bold text-slate-950">Welcome back!</h1>
            <p className="text-slate-600 mt-2">Redirecting you to your analysis...</p>
          </div>
        )}
        {status === "failed" && (
          <div data-testid="resume-failed">
            <h1 className="font-display text-2xl font-bold text-slate-950">Resume link expired</h1>
            <p className="text-slate-600 mt-3">
              This link is no longer valid. Please start a fresh analysis — it only takes 90 seconds.
            </p>
            <button
              data-testid="resume-restart-btn"
              onClick={() => navigate("/analyze")}
              className="btn-primary mt-6 inline-flex"
            >
              Start fresh
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
